import * as moment from 'moment'

export class BankaccountModel {
  id: number
  type: string
  iban: string
  name: string
  balance: number
  balance_date: any
  bank: string
  state: string

  constructor(data) {
    this.id = data.id ? data.id : null
    this.type = data.type ? data.type : null
    this.iban = data.iban ? data.iban : null
    this.name = data.name ? data.name : null
    this.balance = data.balance ? data.balance : 0
    this.balance_date = moment(data.balance_date)
    this.state = data.state
    this.bank = data.bank_name
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/bankaccount.model.ts